/*
 * Copyright (c) 2023 Puratos. All rights reserved.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { ResultsTable } from '../../molecules/list/ResultsTable';
import { RoleMatrix } from '../../../../utils/my-puratos/roleUtils';
import connect from 'react-redux/es/connect/connect';
import { WithMessage } from '../../hoc/withMessage';
import CheckoutCard from '../../molecules/checkout/CheckoutCard';
import CartListHeaderMobile from '../../atoms/checkout/CartListHeaderMobile';
import { deleteItem, setCartActiveItem, updateItem } from '../../../../actions/my-puratos/cart.action';
import { CheckoutPromo } from '../../atoms/checkout/CheckoutPromo';
import { GTMContextProvider } from '../../../../analytics/ga4/utils/GTMContext';
import { SkeletonTypes } from '../../../atoms/effects/skeletons/utils/SkeletonTypes';
import { GA4InteractionType } from '../../../../analytics/ga4/types/interaction';

class CartList extends Component {
    render() {
        const {
            i18n,
            aemResource: listModel,
            children,
            loading,
            cartData,
            onInputChange,
            quickAddItems,
            clearCart,
            inOverview,
            addToCart,
            allowedRoles,
            notAllowedRoles,
            eCommerceRequired,
            excelImportEnabled,
            count,
        } = this.props;

        return (
            <React.Fragment>
                <WithMessage
                    loading={loading}
                    messages={listModel}
                    data={["don't remove"]}
                    allowedRoles={allowedRoles}
                    notAllowedRoles={notAllowedRoles}
                    eCommerceRequired={eCommerceRequired}
                >
                    {cartData && (
                        <CartListHeaderMobile
                            i18n={i18n}
                            title={listModel.cartTitle}
                            clearCart={clearCart}
                            quickAddItems={quickAddItems}
                            onInputChange={onInputChange}
                            addToCart={addToCart}
                        />
                    )}

                    <CheckoutPromo cartData={cartData} view={'mobile'} />

                    <React.Fragment>
                        <div className="row">
                            <div className="col-xs-12 checkout-card__wrapper">
                                <CheckoutCard className="cart__content--overview-products">
                                    <GTMContextProvider type={GA4InteractionType.quickAddProduct}>
                                        <ResultsTable
                                            i18n={i18n}
                                            loading={loading}
                                            skeletonType={SkeletonTypes.CART}
                                            cart={cartData}
                                            isCart={true}
                                            listModel={listModel}
                                            onInputChange={onInputChange}
                                            addToCart={addToCart}
                                            quickAddItems={quickAddItems}
                                            clearCart={clearCart}
                                            count={count}
                                            excelEnabled={excelImportEnabled}
                                            inOverview={inOverview}
                                        >
                                            {children}
                                        </ResultsTable>
                                    </GTMContextProvider>
                                </CheckoutCard>
                            </div>
                        </div>
                    </React.Fragment>
                </WithMessage>
            </React.Fragment>
        );
    }
}

CartList.propTypes = {
    handleSearchInput: PropTypes.func,
    loading: PropTypes.bool,
};

CartList.defaultProps = {
    loading: true,
    allowedRoles: [RoleMatrix.puratosCustomerValidated, RoleMatrix.puratosCustomerNoAuth],
    notAllowedRoles: [RoleMatrix.puratosNoCustomer, RoleMatrix.puratosCustomerUnvalidated],
};

const mapStateToProps = state => ({
    i18n: state.myPuratos_i18n.i18n,
    excelImportEnabled: Object.keys(state.myPuratos_excelImport.aemResource).length !== 0,
    cartInputDisabled: state.myPuratos_cart.disabled,
});

export default connect(mapStateToProps, {
    setActive: setCartActiveItem,
    updateItem: updateItem,
    deleteItem: deleteItem,
})(CartList);
